import { BarList } from "@tremor/react";
import ChartCard from "../../../../shared/charts/ChartCard";

/**
 * codex.md v4 — Top Clients by YTD invoiced (SEK). Tremor BarList.
 *
 * `data`    – rows from toTopClientsBars(apiRows).
 * `loading` – true while the endpoint is still fetching; keeps the
 *             "no data" message suppressed so users don't see a false
 *             empty state during the initial paint.
 */
export default function TopClientsChart({ data, canSee, loading }) {
  if (!canSee) return null;
  return (
    <ChartCard
      title="Top Clients — YTD invoiced"
      subtitle="Top 5 by invoiced revenue · aggregated per client from Monday snapshot"
    >
      {loading
        ? <Loading />
        : data.length === 0
          ? <Empty />
          : (
            <BarList
              data={data}
              className="mt-2"
              color="emerald"
              valueFormatter={(v) => `${v.toLocaleString()} kr`}
            />
          )}
    </ChartCard>
  );
}

function Empty() {
  return (
    <div style={{ textAlign: "center", padding: "32px 0", color: "#6889b4", fontSize: 12 }}>
      No invoice data yet — click ⟳ Sync Monday on the Monthly Billing chart.
    </div>
  );
}

function Loading() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 12 }}>
      {[1, 2, 3, 4, 5].map((i) => (
        <div key={i} style={{
          height: 20,
          borderRadius: 4,
          background: "linear-gradient(90deg, #14213d 0%, #1c2e52 50%, #14213d 100%)",
          opacity: 0.6,
        }} />
      ))}
    </div>
  );
}
